import styled from "styled-components";
import { Tabs } from "components/UI/Tabs/Tabs";
import Card from "components/UI/Card";

import Media from "../../../utils/media";

export const StyledCard = styled(Card)`
  width: 100%;
  max-width: 326px;
  height: auto;
`;

export const StyledTabs = styled(Tabs)`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 72px - 16px);
  ${Media.tablet`max-height: 480px;`}

  .tab-contents {
    overflow-y: hidden;
  }
`;

export const SearchBar = styled.div`
  box-sizing: border-box;
  flex: none;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid
    ${props => (props.theme.darkMode ? "#5d5d5d" : "#dcdcdc")};
`;

export const SearchInput = styled.input`
  margin-left: 16px;
  background: transparent;
  color: ${props => (props.theme.darkMode ? "white" : "black")};
  border: none;
  width: 100%;
  font-size: 18px;
  outline: none;
`;
